import React, { useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { staysOnSameLayout } from "../layouts/headerLayoutPaths";

export const DRAWER_MODAL_PROPS = {
  disableRestoreFocus: true,
};

export const DRAWER_LEAVE_FALLBACK_MS = 80;

export function isModifiedClick(event) {
  return (
    event.metaKey ||
    event.altKey ||
    event.ctrlKey ||
    event.shiftKey ||
    (typeof event.button === "number" && event.button !== 0)
  );
}

export function useDeferredHistoryPush(history) {
  const pendingRef = useRef(null);
  const [token, setToken] = useState(0);

  const flushPush = () => {
    const dest = pendingRef.current;
    if (!dest) {
      return;
    }
    pendingRef.current = null;
    if (history && typeof history.push === "function") {
      history.push(dest);
    }
  };

  const requestPush = (path) => {
    if (!path) {
      return;
    }
    pendingRef.current = path;
    setToken((n) => n + 1);
  };

  useEffect(() => {
    if (!pendingRef.current) {
      return undefined;
    }
    const id = window.setTimeout(flushPush, DRAWER_LEAVE_FALLBACK_MS);
    return () => window.clearTimeout(id);
  }, [token]);

  return {
    requestPush,
    flushPush,
    slideProps: { onExited: flushPush },
  };
}

/**
 * Same-layout drawer taps use the real Link so the shared header stays mounted.
 * Cross-layout taps close the drawer first and navigate after Slide onExited.
 */
export function handleDrawerLinkClick(event, options) {
  const { closeDrawer, to, locationPathname, onLeaveLayout } = options || {};
  if (event.defaultPrevented || isModifiedClick(event)) {
    return;
  }
  event.stopPropagation();
  if (typeof closeDrawer === "function") {
    closeDrawer();
  }
  const dest =
    typeof to === "string" && to
      ? to
      : event.currentTarget && event.currentTarget.getAttribute("href");
  if (staysOnSameLayout(locationPathname, dest)) {
    return;
  }
  event.preventDefault();
  if (typeof onLeaveLayout === "function" && dest) {
    onLeaveLayout(dest);
  }
}

function DrawerNavLinkBase({
  to,
  history,
  location,
  match: _match,
  staticContext: _staticContext,
  onClose,
  onLeaveLayout,
  children,
  style,
  ...rest
}) {
  return (
    <Link
      {...rest}
      to={to}
      style={{ textDecoration: "none", ...style }}
      onClick={(event) =>
        handleDrawerLinkClick(event, {
          closeDrawer: onClose,
          to,
          locationPathname: location && location.pathname,
          onLeaveLayout,
        })
      }
    >
      {children}
    </Link>
  );
}

export const DrawerNavLink = withRouter(DrawerNavLinkBase);
